import { Association } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Association';
import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';

export class AssociationExtend {
  public static Init(dto: Association) {
    dto.relationshipType = EnumRelationshipType.Association;
    dto.sourceMultiplicity = EnumMultiplicity.ZeroMany;
    dto.targetMultiplicity = EnumMultiplicity.ZeroOne;
  }
}
